module.exports = __webpack_public_path__ + "img/67.341187a7.png";